import { jsx } from "react/jsx-runtime";
import { Button, Text } from "pcln-design-system";
import react from "react";
const InlineCitationLink = (props)=>{
    const { metadata } = props;
    return /*#__PURE__*/ jsx(react.Fragment, {
        children: metadata.citationNumber?.split(',')?.map((cn, index)=>/*#__PURE__*/ jsx(Button, {
                variation: "link",
                mx: 1,
                style: {
                    transform: 'translateY(-5px)'
                },
                children: /*#__PURE__*/ jsx(Text.span, {
                    fontSize: "10px",
                    children: cn
                })
            }, `citation-link-${index}`))
    });
};
export { InlineCitationLink };
